import React from "react";
import { useSelector } from "react-redux";

import AccountPopper from "./AccountPopper";
import ConnectWalletButton from "./ConnectWalletButton";

function WalletButton() {
  const accountAddress = useSelector((state) => state.accountSlice.address);

  return accountAddress ? <AccountPopper /> : <ConnectWalletButton />;
}

export default WalletButton;
